export default __webpack_public_path__ + "static/media/bin_gray.31d3d5db.svg";